<template>
  <div class="SystemArguments">
    <div class="title">
      <div>名称</div>
      <div>内容(金额为分)</div>
      <div>链接</div>
      <div>系统参数</div>
      <div>状态</div>
      <div>操作</div>
    </div>
    <div class="center" v-for="(data,index) in SystemArgumentsData">
      <div>
        <input class="text" type="text" v-model="data.title" />
      </div>
      <div>
        <input
          v-if="data.type!=1&&data.type!=7&&data.type!=9"
          class="text"
          type="text"
          v-model="data.content"
        />
        <button
          @click="ConfigImg(data)"
          class="button"
          v-if="data.type==1||data.type==7||data.type==9||data.type==11"
        >修改</button>
      </div>
      <div>
        <input class="text" type="text" v-model="data.url" />
      </div>

      <div v-if="data.id">
        <span v-if="data.type==1">平台二维</span>
        <span v-if="data.type==2">下载地址</span>
        <span v-if="data.type==3">用户协议</span>
        <span v-if="data.type==4">版本号</span>
        <span v-if="data.type==5">规则说明</span>
        <span v-if="data.type==6">提款手续费</span>
        <span v-if="data.type==7">新手课堂Logo</span>
        <span v-if="data.type==8">奖励金额</span>
        <span v-if="data.type==9">IOS下载图片</span>
        <span v-if="data.type==10">盟友实名奖励金额（分）</span>
        <span v-if="data.type==11">微信客服</span>
        <span v-if="data.type==12">控制保险奖励</span>
      </div>
      <div v-if="!data.id">
        <select v-model="data.type" style="width: 100%;height: 100%;border: none;">
          <option value="1">平台二维</option>
          <option value="2">下载地址</option>
          <option value="3">用户协议</option>
          <option value="4">版本号</option>
          <option value="5">规则说明</option>
          <option value="6">提款手续费</option>
          <option value="7">新手课堂Logo</option>
          <option value="8">奖励金额</option>
          <option value="9">IOS下载图片</option>
          <option value="10">盟友实名奖励金额（分）</option>
          <option value="11">微信客服</option>
          <option value="12">控制保险奖励</option>
        </select>
      </div>

      <div>
        <input
          style="position: relative; top: 2px;"
          :name="'SType'+index"
          value="1"
          type="radio"
          v-model="data.state"
        />
        上架
        <input
          value="2"
          style="position: relative; top: 2px;"
          :name="'SType'+index"
          type="radio"
          v-model="data.state"
        />
        下架
      </div>
      <div>
        <button style="margin-left:10px;" class="button" @click="save(data)">保存</button>
        <button style="margin-left:10px;" class="button" @click="Delete(data,index)">删除</button>
      </div>
    </div>

    <button
      style="float: right;margin: 10px;margin-right: 0px;"
      class="button"
      @click="Add()"
    >增加系统参数</button>
    <!-- 上传IOS安装包：
    <input type="file" name="file" id="uploadingISO" @change="uploadingISO" />
    上传IOS配置文件：
    <input type="file" name="file" id="uploadingConfig" @change="uploadingConfig" />-->
    <div style="margin-top:20px">
      上传安卓安装包：
      <input type="file" name="file" id="uploadingA" @change="uploadingA" />
    </div>
    <Page :total="total" @on-change="pagingSuery" show-elevator />
  </div>
</template>

<script>
import Vue from "vue";
/*引入资源请求插件*/
import VueResource from "vue-resource";
/*使用VueResource插件*/
Vue.use(VueResource);
import { api } from "../biz/api";
//分页
import Paginate from "vuejs-paginate";
import ConfigImg from "../components/ConfigImg";
export default {
  name: "SystemArguments",
  components: {
    Paginate,
    ConfigImg
  },
  data() {
    return {
      SystemArgumentsData: [
        {
          id: "", //id
          title: "", //名称
          content: "", //内容
          url: "", //链接
          type: "", //系统参数 例如1平台二维码 2下载地址 3用户协议 4版本号 5规则说明 6提款手续费 7新手课堂Logo 8奖励金额(展示)
          state: "" //状态
        }
      ],
      pageNow: 1,
      total: 1
    };
  },
  mounted: function() {
    this.getData(this.pageNow);
  },
  methods: {
    pagingSuery(pageNow) {
      this.getData(pageNow);
    },
    getData(pageNow) {
      api.Systempselect(pageNow).then(data => {
        this.SystemArgumentsData = data.body.data.list;
        this.total = data.body.data.total;
      });
    },

    save(data) {
      if (data.id) {
        api.Systempupdate(data).then(res => {
          this.$layer.alert(res.body.message);
          this.getData(this.pageNow);
        });
      } else {
        api.Systempadds(data).then(res => {
          this.$layer.alert(res.body.message);
          this.getData(this.pageNow);
        });
      }
    },
    ConfigImg(data) {
      if (!data.id) {
        this.$layer.alert("请先保存再修改图片");
      } else {
        this.$layer.iframe({
          content: {
            content: ConfigImg, //传递的组件对象
            parent: this, //当前的vue对象
            data: { data: data, type: "XT" } //props
          },
          area: ["700px", "900px"],
          title: "修改图片",
          cancel: () => {
            this.getData();
          }
        });
      }
    },
    uploadingA(e) {
      var formData = new FormData();
      formData.append("file", $("#uploadingA")[0].files[0]);
      api.AndroidUpload(formData).then(res => {
        this.$layer.alert(res.body.data[0].path);
      });
    },
    uploadingConfig(e) {
      var formData = new FormData();
      formData.append("file", $("#uploadingConfig")[0].files[0]);
      api.AndroidUpload(formData).then(res => {
        this.$layer.alert(res.body.data[0].path);
      });
    },
    uploadingISO(e) {
      var formData = new FormData();
      formData.append("file", $("#uploadingISO")[0].files[0]);
      api.Iosdeployupload(formData).then(res => {
        this.$layer.alert(res.body.data[0].path);
      });
    },
    Add() {
      this.SystemArgumentsData.push({
        title: "", //名称
        content: "", //内容
        url: "", //链接
        type: 1, //系统参数 例如1平台二维码 2下载地址 3用户协议 4版本号 5规则说明 6提款手续费 7新手课堂Logo 8奖励金额(展示)
        state: "" //状态
      });
    },
    Delete(data, index) {
      var mylay = this.$layer.alert("删除！！！", () => {
        if (data.id) {
          api.Systempdelete(data.id).then(res => {
            this.$layer.close(mylay);
            this.$layer.alert(res.body.message);
            this.getData(this.pageNow);
          });
        } else {
          this.SystemArgumentsData.splice(index, 1);
          this.$layer.close(mylay);
        }
      });
    }
  }
};
</script>
<style scoped>
.SystemArguments {
  background: #fff;
  padding: 15px;
  height: 100%;
  overflow: auto;
}
.title {
  border-top: 1px solid rgba(0, 0, 0, 0.4);
  border-right: 1px solid rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: space-around;
}
.title div {
  border-left: 1px solid rgba(0, 0, 0, 0.4);
  border-bottom: 1px solid rgba(0, 0, 0, 0.4);
  width: 20%;
  line-height: 35px;
  text-align: center;
}
.center {
  border-right: 1px solid rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: space-around;
}
.center div {
  border-left: 1px solid rgba(0, 0, 0, 0.4);
  border-bottom: 1px solid rgba(0, 0, 0, 0.4);
  width: 20%;
  line-height: 35px;
  text-align: center;
}
.center .text {
  width: 100%;
  height: 100%;
  border: none;
  text-align: center;
}
.calendar {
  width: 698px;
  height: 300px;
  z-index: 10;
  position: absolute;
}
</style>